import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { AdminCompany } from "../../../domain/administrator/model";

type AdminCompanyUpdateState = {
  loading: boolean;
  data: AdminCompany;
  error: unknown;
};

const initialState: AdminCompanyUpdateState = {
  loading: false,
  data: {
    name: "",
    paid: false,
    id: "",
    activity: null,
    color: null,
    employeesTreatment: null,
    image: null,
    numberOfEmployees: null,
    cnpj: null,
    operationField: null,
    createdAt: null,
    updatedAt: null,
  },
  error: null,
};

const dataSlice = createSlice({
  name: "admin-update-company",
  initialState: initialState,
  reducers: {
    initAdminUpdateCompany: () => {
      return { ...initialState };
    },
    startAdminUpdateCompany: (state) => {
      state.loading = true;
    },
    successAdminUpdateCompany: (state, action: PayloadAction<AdminCompany>) => {
      state.loading = false;
      state.data = action.payload;
    },
    errorAdminUpdateCompany: (state, action: PayloadAction<unknown>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  initAdminUpdateCompany,
  startAdminUpdateCompany,
  successAdminUpdateCompany,
  errorAdminUpdateCompany,
} = dataSlice.actions;

export default dataSlice.reducer;
